import React, { useEffect, useState } from 'react';

const SmoothTradingSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-black"></div>
      
      <div className={`relative z-10 max-w-7xl mx-auto px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Section Title */}
        <h2 className="text-5xl md:text-6xl font-bold text-center mb-20 animate-scale-in">
          <span className="text-yellow-500">Smooth</span> trading experience
        </h2>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-12">
          {/* Deposit $100 */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 hover-lift hover-glow animate-fade-in-up">
            <h3 className="text-3xl md:text-4xl font-bold animate-fade-in-left mb-4 px-4 pt-4">
              Deposit just <span className="text-yellow-500">$100</span>
              <br />
              <span className="text-gray-400 text-2xl">to start trading</span>
            </h3>
            <img 
              src="/images/Design 12.png" 
              alt="Design 12" 
              className="w-full h-auto object-contain hover-scale transition-transform duration-500"
              loading="lazy"
            />
          </div>

          {/* 24/7 Local Assets */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 hover-lift hover-glow animate-fade-in-up animate-delay-100">
            <h3 className="text-3xl md:text-4xl font-bold animate-fade-in-right mb-4 px-4 pt-4">
              <span className="text-yellow-500">24/7</span> local
              <br />
              <span className="text-gray-400 text-2xl">assets</span>
            </h3>
            <img 
              src="/images/Design 13.png" 
              alt="Design 13" 
              className="w-full h-auto object-contain hover-scale transition-transform duration-500"
              loading="lazy"
            />
          </div>

          {/* Increased Profitability */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 hover-lift hover-glow animate-fade-in-up animate-delay-200">
            <h3 className="text-3xl md:text-4xl font-bold animate-fade-in-left mb-4 px-4 pt-4">
              Increased profitability
              <br />
              <span className="text-yellow-500">of up to 93%</span>
            </h3>
            <img 
              src="/images/Design 14.png" 
              alt="Design 14" 
              className="w-full h-auto object-contain hover-scale transition-transform duration-500"
              loading="lazy"
            />
          </div>

          {/* Beginner-Friendly System */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-gray-800 hover-lift hover-glow animate-fade-in-up animate-delay-300">
            <h3 className="text-3xl md:text-4xl font-bold animate-fade-in-right mb-4 px-4 pt-4">
              <span className="text-yellow-500">Beginner-Friendly</span>
              <br />
              <span className="text-gray-400 text-2xl">System</span>
            </h3>
            <img 
              src="/images/Design 15.png" 
              alt="Design 15" 
              className="w-full h-auto object-contain hover-scale transition-transform duration-500"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmoothTradingSection;
